export default "__VITE_ASSET__Lq3ECuyz__"